import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import DynamicTable from '../../../../components/DynamicTable/DynamicTable'

const ProductExpiryDateModal = ({
  onClose,
  expiryDates,
}: {
  onClose: () => void
  expiryDates: string[]
}) => {
  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      title={'Expiry Dates'}
      disableFooter={true}
      body={
        <DynamicTable
          id='csp-list-table'
          data={expiryDates}
          sortableColumns={[
            {
              label: 'Expiry Date',
              key: 'expiry_date',
              sortable: true,
              sortableDirection: 'asc',
            },
          ]}
          loading={false}
          TableRow={({row}: any) => {
            return (
              <tr>
                <td>{row}</td>
              </tr>
            )
          }}
        />
      }
    />
  )
}

export default ProductExpiryDateModal
